const AccordionPanel = (props) => {
	const { children, ...rest } = props;
	const { outerLookAndFeelClass = "" } = rest;
	// console.log(children);
	return (
		<div data-react="AccordionPanel" className={outerLookAndFeelClass}>
			{!children.map
				? children
				: children.map((child, idx) => {
						return wp.element.cloneElement(child, rest);
				  })}
		</div>
	);
};

export default AccordionPanel;
